import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {Auth, BaseCmsComponent, BaseSite, User} from '@kion/data-models';
import {CmsConfig} from '../../config/cms.config';
import {NavigationStart, Router, RouterStateSnapshot} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {SubSink} from 'subsink';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {AuthsFacade} from '@kion/data-access/data-access-auths';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {UsersFacade} from '@kion/data-access/data-access-users';
import {DOCUMENT} from '@angular/common';
import {MsalService} from '@kion/core';
import {BaseSitesFacade} from "@kion/data-access/data-access-base-sites";

@Component({
  selector: 'kion-cms-login-checkout',
  templateUrl: './login-checkout.component.html',
  styleUrls: ['./login-checkout.component.scss']
})
export class LoginCheckoutComponent implements OnInit, OnDestroy {

  @Input() component: BaseCmsComponent;

  readonly basketRoute: string;
  readonly checkoutStepFirstRoute: string;

  userName$: Observable<string>;
  user$: Observable<Auth>;
  guestCheckoutEnabled$: Observable<boolean> | undefined;

  private subSink: SubSink;
  private window: Window;

  constructor(
    private cmsConfig: CmsConfig,
    private router: Router,
    private cookieService: CookieService,
    private authsFacade: AuthsFacade,
    private usersFacade: UsersFacade,
    private baseSitesFacade: BaseSitesFacade,
    private msalService: MsalService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.window = this.document.defaultView;
    this.subSink = new SubSink();
    this.basketRoute = '/' + this.cmsConfig.routes?.basketBaseRoute;
    this.checkoutStepFirstRoute =  this.cmsConfig.routes?.checkoutBaseRoute + '/' + this.cmsConfig.routes?.checkoutRoutes?.address;
    const snapshot: RouterStateSnapshot = this.router.routerState.snapshot;
    this.subSink.sink = this.router.events.subscribe(
      event =>  {
        if (event instanceof NavigationStart) {
          if (event.url.indexOf(this.cmsConfig.routes?.authBaseRoute) !== -1) {
            this.cookieService.set('_redirect', snapshot.url, 200, '/', null, true, "Strict");
            this.cookieService.set('_checkout', "true", 200, '/', null, true, "Strict");
          }
        }
      }
    );
  }

  ngOnInit(): void {
    this.guestCheckoutEnabled$ = this.baseSitesFacade.all$.pipe(
      map((baseSites: BaseSite[]) =>
        baseSites.find((baseSite: BaseSite) => baseSite.id === this.cmsConfig.baseSite)),
      map((baseSite: BaseSite) => baseSite.guestCheckoutEnabled)
    )

    this.userName$ = this.usersFacade.all$.pipe(
      map(
        (users: User[]) => users[0]?.firstName + ' ' + users[0]?.lastName
      )
    );
    this.user$ = this.authsFacade.all$.pipe(
      map(
        (auth: Auth[]) => auth[0]
      )
    );
    const account = this.msalService.getAccount();
    const hasMsalTokenInStore = this.msalService.getRawIdToken();
    this.subSink.sink = this.user$.pipe(take(1)).subscribe(
      auth =>  {
        if (this.cookieService.get('_register') && account && hasMsalTokenInStore && !auth.user) {
          this.router.navigate([this.cmsConfig.routes?.checkoutBaseRoute, this.cmsConfig.routes?.checkoutRoutes?.register]).then(() => {
            this.cookieService.delete('_register')
          });
        }
      }
    )
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
